export const OBJECT_TYPE = {
  DataSource: 1,
  Entity: 2,
};

export const DATA_SOURCE = {
  singular: "Dataset",
  plural: "Datasets",
};

export const ENTITY = {
  singular: "Entitiy",
  plural: "Entities",
};

export const TAGS = {
  singular: "Tag",
  plural: "Tags",
};

const sampleTemplateJSON = {
  view_header: {
    icon: "briefcase|doctor|facility|geography|home|hospital|pills|stethescope|syringe|user|users",
    title: "${FIRST_NAME} ${LAST_NAME}",
    subtitle: "${SPECIALTY}",
    main: [
      {
        name: "NPI",
        value: "${NPI}",
      },
      {
        name: "FULL ADDRESS",
        value: "${ADDRESS1} ${ADDRESS2}",
      },
    ],
    sidebar: [
      {
        type: "email",
        value: "${EMAIL}",
      },
      {
        type: "phone",
        value: "${PHONE}",
      },
      {
        type: "id",
        value: "${MDM_ID}",
      },
    ],
  },
  view_sections: [
    {
      name: "Primary Attributes",
      fields: [
        {
          name: "NPI",
          value: "${NPI}",
          width: "50%",
        },
        {
          name: "Specialty",
          value: "${SPECIALTY}",
          width: "50%",
        },
      ],
    },
    {
      name: "Education",
      fields: [
        {
          name: "Doctorate",
          value: "${Education}",
          width: "100%",
        },
      ],
    },
  ],
  search_sections: [
    {
      name: "NPI",
      fields: [
        {
          name: "NPI",
        },
      ],
    },
    {
      name: "Specialty",
      fields: [
        {
          name: "SPECIALTY",
        },
      ],
    },
  ],
};

export const sampleViewTemplate = JSON.stringify(sampleTemplateJSON, null, 4);
